import { Platform } from '@angular/cdk/platform';
import { Inject, Injectable, Optional } from '@angular/core';
import { NgxMatNativeDateAdapter } from '@angular-material-components/datetime-picker';
import { MAT_DATE_LOCALE } from '@angular/material/core';

/** Data/hora no input com espaço (sem vírgula do pt-BR). */
@Injectable()
export class PrehoxNgxMatNativeDateAdapter extends NgxMatNativeDateAdapter {
    constructor(@Optional() @Inject(MAT_DATE_LOCALE) matDateLocale: string, platform: Platform) {
        super(matDateLocale, platform);
    }

    override format(date: Date, displayFormat: Object): string {
        const formatted = super.format(date, displayFormat);
        return formatted.replace(/,\s*/g, ' ').trim();
    }

    /** Lê o que o próprio `format` escreve (DD/MM/AAAA HH:mm); o `Date.parse` padrão não entende dia/mês. */
    override parse(value: any): Date | null {
        if (typeof value === 'string') {
            const m = value.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[ ,T]+(\d{1,2}):(\d{2}))?$/);
            if (m) {
                const [, d, mo, y, h = '0', mi = '0'] = m;
                const date = new Date(+y, +mo - 1, +d, +h, +mi);
                // rejeita datas que o Date "corrige" sozinho (31/02 vira março)
                return date.getMonth() === +mo - 1 && date.getDate() === +d ? date : this.invalid();
            }
        }
        return super.parse(value);
    }
}
